// extracted by mini-css-extract-plugin
module.exports =  {"icon":"B9PEaaznJw8X4TxtojeD","root":"N5M3KCIt536zTDndf8h5","label":"CTi0BfzTa7VWCzRIx3kS"};